import React from 'react'

import { Header } from '@/components/Header'
import { Title } from '@/components/Title'
import { Feedback } from '@/components/Feedback'

type Props = {
  title: string
  children: React.ReactNode
  showCreateButton?: boolean
  showBackButton?: boolean
}

export const Layout = ({
  title,
  children,
  showCreateButton,
  showBackButton,
}: Props) => {
  return (
    <div>
      <Header
        showCreateButton={showCreateButton}
        showBackButton={showBackButton}
      />
      <Title>{title}</Title>
      {children}
      <Feedback />
    </div>
  )
}
